export default __webpack_public_path__ + "static/media/Obackti.2ee67d07.jpg";